export default __webpack_public_path__ + "static/media/logo.edda0c7b.svg";